function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.71522 19.5749C9.74045 19.5749 9.76569 19.5749 9.79093 19.5749C10.3966 19.5228 10.8761 18.9762 10.8256 18.3515L10.119 7.88725C10.0685 7.26252 9.53856 6.79397 8.93288 6.82C8.3272 6.87206 7.84771 7.4187 7.89818 8.04343L8.60481 18.5076C8.65528 19.1063 9.13477 19.5749 9.71522 19.5749Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1831 19.5488C14.2083 19.5488 14.2335 19.5488 14.2588 19.5488C14.8392 19.5488 15.3187 19.0802 15.3692 18.4815L16.0758 8.01731C16.1263 7.39258 15.6468 6.84594 15.0411 6.79388C14.4354 6.76785 13.9055 7.2364 13.855 7.86113L13.1484 18.3253C13.0979 18.9761 13.5521 19.5227 14.1831 19.5488Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8644 2.21258H16.429L15.2429 0.494577C15.0158 0.182213 14.6625 0 14.3091 0H9.66562C9.28707 0 8.93375 0.182213 8.73186 0.494577L7.54574 2.21258H1.11041C0.504732 2.21258 0 2.73319 0 3.35792C0 3.98265 0.504732 4.50325 1.11041 4.50325H2.0694L3.98738 21.0325C4.18927 22.7245 5.57729 24 7.2429 24H16.7571C18.4227 24 19.8107 22.7245 20.0126 21.0325L21.9306 4.50325H22.8896C23.4953 4.50325 24 3.98265 24 3.35792C23.9748 2.73319 23.47 2.21258 22.8644 2.21258ZM17.7918 20.7462C17.7413 21.2928 17.2871 21.7093 16.7571 21.7093H7.2429C6.71293 21.7093 6.25868 21.2928 6.2082 20.7462L4.31546 4.50325H19.6845L17.7918 20.7462Z",
  fill: "black"
});

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.a9843690.svg";
export { ForwardRef as ReactComponent };